/**
 * Schemas for inter-service integration endpoints (JobPilot ↔ PayPilot).
 *
 * See HANDOFF-CONTRACT.md v1.0 §3 — authoritative spec for the
 * /integrations/jobpilot/onboard-pending endpoint.
 */
import { z } from 'zod';

export const onboardPendingSchema = z.object({
  source: z.literal('jobpilot'),
  source_application_id: z.string().uuid(),
  hai_candidate_id: z.string().uuid(),
  tenant_id: z.string().uuid(),

  // Employee identity
  emp_code: z.string().trim().max(20).optional(),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  email: z.string().email(),
  national_id: z.string().regex(/^\d{13}$/).optional(),
  phone: z.string().optional(),
  birth_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),

  // Position
  department: z.string().min(1),
  position: z.string().min(1),
  start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),

  // Employment terms
  employee_type: z.enum(['monthly', 'daily']).default('monthly'),
  base_salary: z.number().positive().nullable().optional(),  // ⭐ NULL OK
  daily_rate: z.number().positive().optional(),
  hours_per_workday_override: z.number().min(0.5).max(24).optional(),
  pay_only_attended: z.boolean().optional(),

  invite_role: z.enum(['EMPLOYEE']).default('EMPLOYEE'),
});

export type OnboardPendingInput = z.infer<typeof onboardPendingSchema>;
